import React from 'react';

const ActivityChartSkeleton = () => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-wellness elevation-1 border border-border/40">
      {/* Header Skeleton */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-muted/50 rounded-lg animate-pulse" />
          <div>
            <div className="h-5 w-32 bg-muted/50 rounded animate-pulse mb-2" />
            <div className="h-4 w-48 bg-muted/50 rounded animate-pulse" />
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="h-9 w-48 bg-muted/50 rounded-lg animate-pulse" />
          <div className="h-9 w-32 bg-muted/50 rounded-lg animate-pulse" />
        </div>
      </div>
      {/* Chart Area Skeleton */}
      <div className="h-80 flex items-end justify-between space-x-2 px-4">
        {[...Array(7)]?.map((_, index) => (
          <div key={index} className="flex-1 flex flex-col items-center space-y-2">
            <div 
              className="w-full bg-muted/50 rounded-t animate-pulse" 
              style={{ height: `${Math.random() * 60 + 40}%` }}
            />
            <div className="h-3 w-8 bg-muted/50 rounded animate-pulse" />
          </div>
        ))}
      </div>
      {/* Legend Skeleton */}
      <div className="flex items-center justify-center space-x-6 mt-6">
        {[...Array(3)]?.map((_, index) => (
          <div key={index} className="flex items-center space-x-2 animate-pulse">
            <div className="w-3 h-3 bg-muted/50 rounded-full" />
            <div className="h-4 w-16 bg-muted/50 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityChartSkeleton;